import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DummyProducts } from "../../helpers";
import { NavLink, Link } from "react-router-dom";
import { MealItem } from "../../components";
import classes from "./Landing.module.css";
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const Sandwich = () => {
  const { t, i18n } = useTranslation();
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    const bodyEl = document.body;
    if (language == "ar") {
      bodyEl.classList.add("body-rtl");
    } else {
      bodyEl.classList.remove("body-rtl");
    }
  };
  if (localStorage.getItem("i18nextLng")) {
    const bodyEl = document.body;
    if (localStorage.getItem("i18nextLng") == "ar") {
      bodyEl.classList.add("body-rtl");
    } else {
      bodyEl.classList.remove("body-rtl");
    }
  }
  return (
    <div className={classes.HomeSliderSandwich}>
      <div className={`container`}>
        <Swiper
          spaceBetween={27}
          slidesPerView={4}
          speed={1000}
          pagination={false}
          autoplay={{ delay: 4500 }}
          onSlideChange={() => console.log("slide change")}
          onSwiper={(swiper) => console.log(swiper)}
          className={classes.swiperContainerSandwich}
        >
          {DummyProducts().map((row, index) => {
            return (
              <SwiperSlide key={index}>
                <MealItem
                  image={row.image}
                  title={row.title}
                  title_ar={row.title_ar}
                  price={row.price}
                  description={row.description}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className={classes.moreMeals}>
          <NavLink
            className={`main-button ${classes.moreMealsLink}`}
            to={"/menu"}
          >
            {t("see-more-btn")}
          </NavLink>
          {/* {t("welcome")} */}
          {/* <br />
          {i18n.language == "ar" ? (
            <button onClick={() => changeLanguage("en")}>EN</button>
          ) : (
            <button onClick={() => changeLanguage("ar")}>AR</button>
          )}
          <br />
          {i18n.language == "ar" ? "عماد" : "emad"} */}
        </div>
      </div>
    </div>
  );
};

export { Sandwich };
